import React from 'react';

import { Alert, CircularProgress } from '@mui/material';

import NestedAccordion from '~/components/Bedbank/Properties/Home/DynamicConfiguration/NestedAccordion';
import useGetDynamicConfigurations from '~/hooks/apis/accommodation/useGetDynamicConfigurations';

export default function DynamicConfigurationsPage() {
  const { data, isLoading, isError, error } = useGetDynamicConfigurations();

  if (isLoading) {
    return <CircularProgress />;
  }

  if (isError) {
    return <Alert severity="error">{error instanceof Error ? error.message : 'Error loading dynamic configurations'}</Alert>;
  }

  return (
    <>
      {Object.entries(data ?? {}).map(([key, value]) => (
        <NestedAccordion key={key} keyName={key} value={value} />
      ))}
    </>
  );
}
